import type { FeatureGroup } from '../../types';

export const CRM_FEATURE_GROUP: FeatureGroup = {
  guid: 'c7d2e5b8-1a43-4c69-8b27-6e9f1d2a0000',
  name: 'crm',
  description: 'Root group for all CRM features — dashboard, tickets, memberships, donations and events',
  product: 'crm',
};
